import moment from 'moment';

export default angular
  .module('app.holding.dashboard.overview')
  .filter('holdingStartOfMonth', holdingStartOfMonth)
  .name;

function holdingStartOfMonth() {
  'ngInject';

  return (input) => {
    return moment(input).startOf('month').format('DD MMM YYYY');
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/overview/filters/start-of-month.js